export default "__VITE_ASSET__76dbeb7e__"